import { faFax, faPhone } from "@fortawesome/free-solid-svg-icons";
import { ButtonIcon } from "Components/Icon";
import React from "react";
import { CSSProperties } from "styled-components";
import { SimpleFieldProps } from "./FormTools";
import { Textbox } from "./Textbox";
import { YupDefined } from "./Tools";

export function PhoneInput(props: {
  fieldProps: SimpleFieldProps<string | null>;
  placeholder?: string;
  className?: string;
  type?: string;
  isDisabled?: boolean;
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
  style?: CSSProperties;
}) {
  return (
    <Textbox
      {...props}
      type="tel"
      cleaveOptions={{
        numericOnly: true,
        blocks: [0, 3, 3, 4],
        delimiters: ["(", ") ", "-"],
      }}
      leftIconContent={<ButtonIcon className="is-left" icon={faPhone} />}
    />
  );
}

export function FaxInput(props: {
  fieldProps: SimpleFieldProps<string | null>;
  placeholder?: string;
  className?: string;
  type?: string;
  isDisabled?: boolean;
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>;

  style?: CSSProperties;
}) {
  return (
    <Textbox
      {...props}
      type="tel"
      cleaveOptions={{
        numericOnly: true,
        blocks: [0, 3, 3, 4],
        delimiters: ["(", ") ", "-"],
      }}
      leftIconContent={<ButtonIcon className="is-left" icon={faFax} />}
    />
  );
}

PhoneInput.getDefaultValidator = (options: {
  isRequired?: true;
  label?: string;
}) => {
  const baseValidator = YupDefined.string()
    .nullable()
    .length(10, () => `Please enter a valid phone number`)
    .label(options.label ?? "Phone");
  return options.isRequired === true ? baseValidator.required() : baseValidator;
};
